import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom"; // 🌟 引入 useNavigate
// import "./assets/style.css"; // 请确保样式文件路径正确

const Login = ({ setAuthenticated }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const navigate = useNavigate(); // 🌟 用于登录成功后的页面跳转

  useEffect(() => {
    document.body.classList.add("login-body");
    return () => {
      document.body.classList.remove("login-body");
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage(""); // 每次提交前清空错误

    try {
      const response = await axios.post('/auth/login', { email, password });

      // 🌟 核心步骤 1：把后端给的 Token 存在浏览器的 localStorage 里！
      localStorage.setItem("user_token", response.data.token);
      // 可选：把用户的名字也存下来，方便在导航栏显示 "Hello, XX"
      if (response.data.firstname) {
        localStorage.setItem("user_firstname", response.data.firstname);
      }

      // 🌟 核心步骤 2：更新状态并跳转
      setAuthenticated(true);
      alert("登录成功！");
      navigate("/"); // 登录成功后跳回首页或大模型对话页

    } catch (error) {
      // 🌟 核心步骤 3：精准捕获后端的报错信息（比如：邮箱未激活、密码错误）
      const errorDetail = error.response?.data?.detail;
      const errorMsg = typeof errorDetail === 'string' ? errorDetail : "Login failed. Please check your credentials.";
      setErrorMessage(errorMsg);
    }
  };

  return (
    <div className="login-wrapper">
      <h1 className="login-h1">Login</h1>

      {/* 🌟 错误信息展示优化 */}
      {errorMessage && <p id="error-message" style={{color: '#ff4d4f', fontSize: '14px', marginBottom: '10px'}}>{errorMessage}</p>}

      <form id="login-form" className="login-form" onSubmit={handleSubmit}>
        <div className={`login-input-wrapper ${errorMessage ? "incorrect" : ""}`}>
          <label htmlFor="email-input">
            <span>@</span>
          </label>
          <input
            type="email"
            name="email"
            id="email-input"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className={`login-input-wrapper ${errorMessage ? "incorrect" : ""}`} style={{ marginBottom: '5px' }}>
          <label htmlFor="password-input">
            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
              <path d="M240-80q-33 0-56.5-23.5T160-160v-400q0-33 23.5-56.5T240-640h40v-80q0-83 58.5-141.5T480-920q83 0 141.5 58.5T680-720v80h40q33 0 56.5 23.5T800-560v400q0 33-23.5 56.5T720-80H240Zm240-200q33 0 56.5-23.5T560-360q0-33-23.5-56.5T480-440q-33 0-56.5 23.5T400-360q0 33 23.5 56.5T480-280ZM360-640h240v-80q0-50-35-85t-85-35q-50 0-85 35t-35 85v80Z" />
            </svg>
          </label>
          <input
            type="password"
            name="password"
            id="password-input"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        {/* 🌟 核心步骤 4：另起一行处理“忘记密码” */}
        <div style={{ textAlign: 'right', marginBottom: '20px' }}>
          <Link to="/forgot-password" style={{ fontSize: '12px', color: '#666', textDecoration: 'none' }}>
            Forgot Password?
          </Link>
        </div>

        <button type="submit">Login</button>
      </form>

      <p>
        New here? <Link className="login-a" to="/signup">Create an Account</Link>
      </p>
    </div>
  );
};

export default Login;